import React from 'react';
import Typography from '@mui/material/Typography';
import { Tweet } from 'react-twitter-widgets';
import { YoutubePlayer } from './Youtube.js';
import { extractIdFromUrl, isYoutubeUrl, isTwitterUrl } from '../utils/string.js';
import { format_timedelta } from '../utils/time.js';
import { Link } from './Link.js';
import { OGPLoad } from './OGPLoad.js';

// libs/src/components/VideoPreview.tsx
const VideoPreview = ({
  url,
  title,
  seek_offset = 0
}) => {
  const id = extractIdFromUrl(url);
  const _url = isYoutubeUrl(url) ? `https://www.youtube.com/watch?v=${id}&t=${seek_offset}` : url;
  const CommonPreview = ({
    children
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    sx: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    href: _url,
    external: true
  }, title || _url, ' ', Boolean(seek_offset) && `(${format_timedelta(seek_offset)})`)));
  return !url ? /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    sx: {
      textAlign: 'center'
    }
  }, "\u52D5\u753B\u306F\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F") : isYoutubeUrl(url) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CommonPreview, null, /*#__PURE__*/React.createElement(YoutubePlayer, {
    sx: {
      borderRight: '1px solid #eaeaea'
    },
    videoId: id,
    start: seek_offset,
    width: '100%'
  }))) : isTwitterUrl(url) && url.includes('/status/') ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CommonPreview, null, /*#__PURE__*/React.createElement(Tweet, {
    tweetId: id
  }))) : /*#__PURE__*/React.createElement(CommonPreview, null, /*#__PURE__*/React.createElement(OGPLoad, {
    url: url,
    image_height: "200"
  }));
};

export { VideoPreview, VideoPreview as default };
